<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="assets/images/logo/logo.svg" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">Ευανάγνωστο</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a type="button" class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li>
    <!--/ Toggle skin -->
  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- ? Language selection | Uncomment if needed-->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li> -->
    <!--/ Language selection -->

      <!-- Language selection -->
      <li ngbDropdown class="nav-item dropdown dropdown-language">
        <!-- <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
          <img [src]=returnLangImg() style="height: 24px; margin-right: 8px;" />
          <span class="selected-language">{{ returnLang() }}</span></a
        > -->
        <!-- <div ngbDropdownMenu aria-labelledby="dropdown-flag">
          <a ngbDropdownItem (click)="selectImage('gr')">
            <img src="../../../../assets/images/pages/greece.png" style="height: 24px;" /> Ελληνικά
          </a>
          <a ngbDropdownItem (click)="selectImage('en')">
            <img src="../../../../assets/images/pages/united-kingdom.png" style="height: 24px;" /> English
          </a>
        </div> -->
      </li>
      <!--/ Language selection -->
    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name font-weight-bolder">{{returnUserEmail()}}</span>
          <span class="user-status">{{returnUserJob()}}</span>
        </div>
        <span class="avatar"
          ><img
            class="round"
            src={{returnIcon()}}
            alt="avatar"
            height="40"
            width="40" /><span class="avatar-status-online"></span
        ></span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <!-- <a ngbDropdownItem [routerLink]="['/profile']"><span [data-feather]="'user'" [class]="'mr-50'"></span> {{My_Profile}}</a> -->
        <a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'home'" [class]="'mr-50'"></span> {{Dashboard}}</a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem [routerLink]="['/pages/authentication/login-v2']" ><span [data-feather]="'power'" [class]="'mr-50'"></span> {{Logout}}</a
        >
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
